import React from 'react';
import Footer from '../components/Footer';
import Menu from '../components/Menu';

const WebsiteLayout = ({ children }) => {
  return (
    <div className="page-fit">
      <Menu />
      {children}
      <Footer />
    </div>
  );
};

export default WebsiteLayout;